import { getRouteApi } from "@tanstack/react-router";
import { useFamilyAum } from "creso-core/hooks";

export function useFamilyHasHoldings() {
  const route = getRouteApi("/(auth)/_headed/clients/families/$id");
  const { family } = route.useLoaderData();
  const { data: aumOverview } = useFamilyAum(family.id, "OVERALL");

  if (!aumOverview) return undefined;
  return Number(aumOverview.summary.invested_value) > 0;
}
